import React from 'react';
import { useDarkMode } from '../contexts/DarkModeContext';
import DescriptionRenderer, { DescriptionSegment } from './DescriptionRenderer';

interface DescriptionGroupProps {
    description: DescriptionSegment[];
}

const DescriptionGroup: React.FC<DescriptionGroupProps> = ({ description }) => {
    const { isDarkMode } = useDarkMode();

    return (
        <>
            {description && (
                <div>
                    <div>
                        <DescriptionRenderer description={description} />
                    </div>
                </div>
            )}
        </>
    );
};

export default DescriptionGroup;


